<app-card
  size="large"
  [border]="true"
  [background]="true"
  [spacingBottom]="spacingBottom"
>
  <app-view
    [gap]="Spacing.MEDIUM"
    [align]="ViewAlign.CENTER"
    [spacingBottom]="Spacing.SMALL"
    [spacingTop]="Spacing.SMALL"
  >
    <app-text
      [color]="TextColor.NEUTRAL_6"
      [weight]="TextWeight.REGULAR"
      [size]="TextSize.BODY_2"
      [height]="TextHeight.BODY_2"
      >{{ message }}</app-text
    >
    <app-button
      [type]="ButtonType.PRIMARY"
      [size]="ButtonSize.SMALL"
      [disabled]="buttonDisabled"
      [buttonIcon]="buttonIcon"
      (handleClick)="onButtonClick()"
      [title]="buttonTitle"
      [spacingBottom]="Spacing.NONE"
    >
      {{ buttonText }}
    </app-button>
  </app-view>
</app-card>
